import React from 'react';
import type {
    SearchSuggestion,
    SearchSuggestionGroup,
} from '../view-models/search-suggestion';
import { SearchSuggestionContent } from './SearchSuggestionContent';
import { cn } from '../../../utils/cn';

interface SearchSuggestionPopupProps {
    suggestionGroups: SearchSuggestionGroup[];
    query: string;
    onSearchSuggestionClick: (suggestion: SearchSuggestion | string) => void;
    variant?: 'default' | 'header';
    menuColor?: 'light' | 'dark';
}

export const SearchSuggestionPopup: React.FC<SearchSuggestionPopupProps> = ({
    suggestionGroups,
    query,
    onSearchSuggestionClick,
    variant = 'default',
    menuColor = 'dark',
}) => {
    const filteredSuggestionGroups = suggestionGroups.filter(
        (group) => group.options.length > 0,
    );

    if (filteredSuggestionGroups.length === 0) {
        return <></>;
    }

    return (
        <div
            className={cn(
                'absolute left-2 right-2 top-full z-popover mt-2 p-8 pl-13.5 pt-9',
                variant === 'header' && menuColor === 'light'
                    ? 'rounded-5 bg-black/20 shadow-lg backdrop-blur-xl'
                    : variant === 'header' && menuColor === 'dark'
                      ? 'bg-gray-100/40 rounded-5 shadow-lg backdrop-blur-xl'
                      : 'scrollbar-hide max-h-[calc(100vh-12rem)] overflow-y-auto rounded-xl border border-gray-300 bg-white shadow-lg',
            )}
            id="search-autocomplete"
            aria-haspopup="listbox"
        >
            <SearchSuggestionContent
                suggestionGroups={filteredSuggestionGroups}
                query={query}
                onSearchSuggestionClick={onSearchSuggestionClick}
                variant={variant}
                menuColor={menuColor}
            />
        </div>
    );
};
